import * as Yup from "yup";

export const clientValidationSchema = (currentClientId, clients) =>
  Yup.object().shape({
    name: Yup.string()
      .required("Client Name is required")
      .test("exists", "Client Name already exists", async (value) => {
        const lowerCase = value.toLowerCase();
        return !clients.some(
          (client) => client.name === lowerCase && client.id !== currentClientId
        );
      }),
    addresses: Yup.array().of(
      Yup.object().shape({
        area: Yup.string().required("Area is required"),
        billing: Yup.boolean().required("Billing Address is required"),
        house_unit_street: Yup.string().required(
          "House/Unit/Street is required"
        ),
        barangay: Yup.string().required("Barangay is required"),
        city: Yup.string().required("City/Municipality is required"),
        metro_province: Yup.string().required("Metro/Province is required"),
        zipcode: Yup.string().required("Zip Code is required"),
      })
    ),
    contacts: Yup.array().of(
      Yup.object().shape({
        firstname: Yup.string().required("First Name is required"),
        lastname: Yup.string().required("Last Name is required"),
        billing: Yup.boolean().required("Billing is required"),
        birthday: Yup.string(),
        numbers: Yup.array().of(
          Yup.object().shape({
            type: Yup.string().required("Type is required"),
            number: Yup.string().required("Number is required"),
          })
        ),
        emails: Yup.array().of(
          Yup.object().shape({
            email: Yup.string().required("Email is required"),
          })
        ),
      })
    ),
    category: Yup.string().required("Category is required"),
    // parent_client: Yup.string(),
    service_types: Yup.array()
      .of(Yup.string().required("Service Type is required"))
      .min(1, "At least one Service Type is required"),
    location_type: Yup.string().required("Location Type is required"),
  });
